import React from "react";
import { Linkedin, Mail, Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const Footer = () => {
    return (
        <footer className="relative border-t border-gold/10 bg-graphite/40" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16">
                <div className="grid lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-5">
                <Link to="/" aria-label="IndoBlitz home"><Logo size={44} testId="footer-logo" /></Link>
                        <p className="mt-5 text-sm text-ivory/55 leading-relaxed max-w-sm">
                            Cross-border technology, talent and AI readiness - engineered in India,
                            delivered globally. <span className="text-gold/80 italic">Crafting young minds.</span>
                        </p>
                        <div className="mt-6 flex items-center gap-3">
                            <a
                                href="https://www.linkedin.com/company/111746209"
                                target="_blank" rel="noopener noreferrer"
                                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:border-gold hover:text-gold transition-colors text-ivory/70"
                                aria-label="IndoBlitz on LinkedIn"
                                data-testid="footer-linkedin"
                            >
                                <Linkedin className="w-4 h-4" />
                            </a>
                            <a
                                href="https://www.instagram.com/bobby__philips/"
                                target="_blank" rel="noopener noreferrer"
                                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:border-gold hover:text-gold transition-colors text-ivory/70"
                                aria-label="Bobby Philips on Instagram"
                                data-testid="footer-instagram"
                            >
                                <Instagram className="w-4 h-4" />
                            </a>
                            <a
                                href="https://www.facebook.com/bobby.philips"
                                target="_blank" rel="noopener noreferrer"
                                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:border-gold hover:text-gold transition-colors text-ivory/70"
                                aria-label="Bobby Philips on Facebook"
                                data-testid="footer-facebook"
                            >
                                <Facebook className="w-4 h-4" />
                            </a>
                            <a
                                href="mailto:admin@indoblitz.com"
                                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:border-gold hover:text-gold transition-colors text-ivory/70"
                                aria-label="Email"
                                data-testid="footer-email"
                            >
                                <Mail className="w-4 h-4" />
                            </a>
                        </div>
                    </div>

                    <div className="lg:col-span-7 grid sm:grid-cols-3 gap-8">
                        <div>
                            <h4 className="font-mono text-xs uppercase tracking-widest text-gold/70 mb-4">Company</h4>
                            <ul className="space-y-3 text-sm text-ivory/65">
                                <li><Link to="/about" className="hover:text-gold transition-colors">About</Link></li>
                                <li><Link to="/services" className="hover:text-gold transition-colors">Services</Link></li>
                                <li><Link to="/training" className="hover:text-gold transition-colors">Training &amp; Internship</Link></li>
                                <li><Link to="/careers" className="hover:text-gold transition-colors">Careers</Link></li>
                                <li><Link to="/partner" className="hover:text-gold transition-colors">Partner</Link></li>
                                <li><Link to="/csr" className="hover:text-gold transition-colors">CSR activities</Link></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="font-mono text-xs uppercase tracking-widest text-gold/70 mb-4">Regions</h4>
                            <ul className="space-y-3 text-sm text-ivory/65">
                                <li><span>🇮🇳 India (HQ)</span></li>
                                <li><span>🇦🇺 Sydney, Australia</span></li>
                                <li><span>🇦🇪 Dubai, UAE - opening</span></li>
                                <li><span>🌐 Global - USD</span></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="font-mono text-xs uppercase tracking-widest text-gold/70 mb-4">Get in touch</h4>
                            <ul className="space-y-3 text-sm text-ivory/65">
                                <li><a href="mailto:admin@indoblitz.com" className="hover:text-gold transition-colors">admin@indoblitz.com</a></li>
                                <li><Link to="/contact" className="hover:text-gold transition-colors">Schedule a call</Link></li>
                                <li><Link to="/partner" className="hover:text-gold transition-colors">Partner with us</Link></li>
                                <li><Link to="/faq" className="hover:text-gold transition-colors">FAQ</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="gold-rule my-10" />

                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-ivory/40 font-mono">
                    <div>© {new Date().getFullYear()} IndoBlitz. Built rural. Delivered globally.</div>
                    <div className="flex items-center gap-6">
                        <Link to="/contact" className="hover:text-gold transition-colors">Privacy</Link>
                        <Link to="/contact" className="hover:text-gold transition-colors">Terms</Link>
                        <span className="hidden md:inline">v2.0 · 2026</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
